import { Component } from '@angular/core';

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    standalone: false
})
export class CartComponent  {

  public openCart: boolean = false;

  constructor() { }

  

  // For Mobile Device
  toggleCart() {
    this.openCart = !this.openCart;
  }

}
